<template>
  <div class="page-my-account">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-8 is-offset-2">
          <h1 class="title">Mis datos</h1>
        </div>
        <div class="column is-8 is-offset-2 mb-5">
          <h2 class="subtitle"><strong>Datos de cuenta</strong></h2>
          <div class="box">
            <div class="data">
              <div class="data-header">
                <p><strong>Usuario</strong></p>
              </div>
              <div class="data-content">
                <div class="data-hidden-mobile">
                  <div class="overlay"></div>
                  <p>{{ username }}</p>
                </div>
              </div>
              <div class="data-footer">
                <div class="head-quantity">
                  <button class="btn animated">
                    <span class="left-line"></span>
                    <span class="right-line"></span>
                  </button>
                </div>
              </div>
            </div>
            <hr class="line" />
            <div class="data">
              <div class="data-header">
                <p><strong>Email</strong></p>
              </div>
              <div class="data-content">
                <div class="data-hidden-mobile">
                  <div class="overlay"></div>
                  <p>{{ dataUser.email }}</p>
                </div>
              </div>
              <div class="data-footer">
                <div class="head-quantity">
                  <button class="btn animated">
                    <span class="left-line"></span>
                    <span class="right-line"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-8 is-offset-2 mb-5">
          <h2 class="subtitle"><strong>Datos personales</strong></h2>
          <div class="box">
            <div class="data">
              <div class="data-header">
                <p><strong>Nombre y apellido</strong></p>
              </div>
              <div class="data-content">
                <div class="data-hidden-mobile">
                  <div class="overlay"></div>
                  <p>{{ this.nameCompleted }}</p>
                </div>
              </div>
              <div class="data-footer">
                <div class="head-quantity">
                  <button class="btn animated">
                    <span class="left-line"></span>
                    <span class="right-line"></span>
                  </button>
                </div>
              </div>
            </div>
            <hr class="line" />
            <div class="data">
              <div class="data-header">
                <p><strong>Documento</strong></p>
              </div>
              <div class="data-content">
                <div class="data-hidden-mobile">
                  <div class="overlay"></div>
                  <p>{{ dataUser.dni }}</p>
                </div>
              </div>
              <div class="data-footer">
                <div class="head-quantity">
                  <button class="btn animated">
                    <span class="left-line"></span>
                    <span class="right-line"></span>
                  </button>
                </div>
              </div>
            </div>
            <hr class="line" />
            <div class="data">
              <div class="data-header">
                <p><strong>Telefono</strong></p>
              </div>
              <div class="data-content">
                <div class="data-hidden-mobile">
                  <div class="overlay"></div>
                  <p>{{ phone }}</p>
                </div>
              </div>
              <div class="data-footer">
                <div class="head-quantity">
                  <button class="btn animated">
                    <span class="left-line"></span>
                    <span class="right-line"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-8 is-offset-2">
          <h2 class="subtitle"><strong>Domicilio</strong></h2>
          <div class="box">
            <div class="data is-space-bet pt-5">
              <div
                v-for="item in address"
                :key="item.id"
                class="data-address"
              >
                <p class="mb-3">{{item.direction}}</p>
                <small class="is-size-7">
                  <p>
                    <span>{{item.departament.name}}({{item.zipcode}})</span>, 
                    <span>{{item.city.name}}</span>
                  </p>
                  <p>
                    <span>{{ this.nameCompleted }}</span>
                  </p>
                </small>
                <template v-if="dataMissing">
                  <div class="notification mt-3 is-warning is-text-small">
                    <p>Faltan las indicaciones adicionales de este domicilio, completa ese dato para asegurar que tus envios lleguen.</p>
                    <p class="mt-3">Completar indicaciones adicionales</p>
                  </div>
                </template>
              </div>
              <div class="option">
                <span>.</span>
                <span>.</span>
                <span>.</span>
              </div>
            </div>
            <hr class="line" />
            <div class="data is-space-bet">
              <div class="data-header">
                <p class="data-link">Agregar domicilio</p>
              </div>
              <div class="data-footer">
                <div class="head-quantity">
                  <button class="btn animated">
                    <span class="left-line"></span>
                    <span class="right-line"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "MyAccount",
  data() {
    return {
      username: this.$store.state.username,
      dataUser: {},
      address: {},
      dataMissing: false,
      phone: Number
    };
  },
  mounted() {
    document.title = "Mi cuenta | Shoper.co";
    this.getDataUser();
  },
  methods: {
    async getDataUser() {
      try {
        const res = await axios.get("/api/v1/perfil-auth/");
        
        this.dataUser = res.data
        this.address = res.data.get_address
        res.data.get_address.forEach(address => {
          this.dataMissing = Object.values(address).some(none => none === '')
          this.phone = address.phone
        });

      } catch (error) {
        console.error(error);
      }
    },
  },
  computed: {
    nameCompleted () {
      return `${this.dataUser.first_name} ${this.dataUser.last_name}`
    }
  }
};
</script>

<style lang="scss" scoped>
.is-text-small{font-size: 14px;}
.data-link{
  display: inline;
  color: #745192;
  text-decoration: underline;
  cursor: pointer;
}
.box{
  padding: 0;
  .data {
    position: relative;
    display: flex;
    align-items: center;
    padding: .5rem 1rem;
    .data-header{
      max-width: 300px;
      width: 100%;
    }
    .data-content{
      width: 100%;
      .data-hidden-mobile{
        position: relative;
        overflow: hidden;
        max-width: 98px;
        min-width: 100%;
        width: 100%;
        .overlay{
          position: absolute;
          display: block;
          top: 0;
          right: 0;
          bottom: 0;
          border: 1px solid #fff;
          z-index: 10;
          box-shadow: -1px 0 10px 10px rgba(255,255,255,.9);
        }
      }
    }
    .data-footer{
      .head-quantity{
        display: inline-flex;
        .btn{
          position: relative;
          cursor: pointer;
          outline: none;
          border: none;
          margin: 1rem;
          right: 0;
          background-color: transparent;
          :first-child{
            top: -3px;
            transform: rotate(-140deg);
          }
          :last-child{
            transform: rotate(140deg);
            bottom: -3px;
          }
          span{
            position: absolute;
            display: block;
            right: 0;
            background-color: #745192;
            border-radius: 3px;
            height: 2px;
            margin:auto;
            width: 11px;
            animation-duration: 1s;
            animation-fill-mode: forwards;
          }
        }
      }
    }
    .option{
      position: absolute;
      top: 0;
      right: 17px;
      font-size: 30px;
      cursor: pointer;
      span{
        display: inline-flex;
      }
    }
  }
  .line{
    background-color: #e5eff1;
    margin: 0;
  }
}
@media screen and (max-width: 720px) {
  .data {
    p{font-size: 14px;}
    .data-header{
      width: 50%;
    }
    .data-content{
      .data-hidden-mobile{
        width: 50%;
      }
    }
  }
}
</style>